import * as React from "react"

import { cn } from "@/lib/utils"
import { DateInput } from "@/components/ui/date-input"

const DATE_MAX = {
  date: "9999-12-31",
  "datetime-local": "9999-12-31T23:59:59.999",
  month: "9999-12",
  week: "9999-W52",
};

const Input = React.forwardRef((props, ref) =>
  props.type === "date" ? <DateInput ref={ref} {...props} /> : <BaseInput ref={ref} {...props} />
)
Input.displayName = "Input"

const BaseInput = React.forwardRef(({ className, type, max, onChange, value, defaultValue, ...props }, ref) => {
  const lastValidDate = React.useRef(value ?? defaultValue ?? "");
  if (value !== undefined) lastValidDate.current = value ?? "";

  const handleChange = (event) => {
    if (DATE_MAX[type] && event.target.value) {
      const year = event.target.value.match(/^([+-]?\d+)-/)?.[1]?.replace(/^[+-]/, "");
      if (year && year.length > 4) {
        event.target.value = lastValidDate.current;
        return;
      }
    }
    if (DATE_MAX[type]) lastValidDate.current = event.target.value;
    onChange?.(event);
  };

  return (
    <input
      type={type}
      max={DATE_MAX[type] ? (max && max < DATE_MAX[type] ? max : DATE_MAX[type]) : max}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
      value={value}
      defaultValue={defaultValue}
      onChange={handleChange} />
  );
})
BaseInput.displayName = "BaseInput"

export { Input }
